import React, { Component } from 'react'
import { connect } from 'react-redux'
import get from 'lodash.get'
import cuid from 'cuid'
import { Textfit } from 'react-textfit'
import Formsy from 'formsy-react'
import { withRouter } from 'react-router-dom'
import Dropzone from 'react-dropzone'
import { Button, Steps, Icon, message, Tooltip } from 'antd'

import CustomInput from 'components/CustomInput'
import { pendingConfirmDelivery, pendingConfirmUniqueDelivery } from 'screens/LoadsDetails/actions'
import css from './index.scss'
import DefaultDatePicker from '../../../../../../components/DefaultDatePicker'
import TimeSelector from '../../../../../../components/TimeSelector'

const ButtonGroup = Button.Group
const Step = Steps.Step

const truncateText = (text, size) => {
  if (!text) {
    return '--'
  }
  if (text.length > size) {
    return (
      <Tooltip title={text}>
        <span>{text.slice(0, size - 3).concat('...')}</span>
      </Tooltip>
    )
  }
  return text
}
class Client extends Component {
  state = {
    allSectionSelectedItem: null,
    currentIndex: 0,
    pictures: [],
    observation: '',
    destinationMap: {
      ...this.props.load.destinations.map((item) => ({
        ...item,
        observation: '',
        pictures: [],
      })),
    },
    hoveredIndex: null,
  }

  onDropImages = (pictures) => {
    this.setState((prevState) => ({
      destinationMap: {
        ...prevState.destinationMap,
        [prevState.currentIndex]: {
          ...prevState.destinationMap[prevState.currentIndex],
          pictures: [...prevState.destinationMap[prevState.currentIndex].pictures, ...pictures],
        },
      },
    }))
  }

  handleChangeObservation = (e) => {
    this.setState({
      destinationMap: {
        ...this.state.destinationMap,
        [this.state.currentIndex]: {
          ...this.state.destinationMap[this.state.currentIndex],
          observation: e.target.value,
        },
      },
    })
  }

  handlePreviousClick = () => {
    this.setState((prevState) => ({
      currentIndex: prevState.currentIndex - 1,
    }))
  }

  handleNextClick = () => {
    const { destinationMap, currentIndex } = this.state
    const step = destinationMap[currentIndex]
    if (this.props.load?.shipper?.flEfectiveDateDelivery && !step.efectiveDeliveryDate) {
      return message.error('Selecione a data efetiva de entrega.')
    }
    if (step && step.pictures && step.pictures.length) {
      this.setState({
        currentIndex: this.state.currentIndex + 1,
        pictures: [],
      })
    } else {
      message.error('Adicione no mínimo um comprovante de entrega.')
    }
  }

  handlePictureIsHovered = (hoveredIndex) => {
    if (hoveredIndex !== this.state.hoveredIndex) {
      this.setState({
        hoveredIndex,
      })
    }
    if (!this.state.isPictureHovered) {
      this.setState({
        isPictureHovered: true,
      })
    }
  }

  handlePictureIsNotHovered = () => {
    if (this.state.isPictureHovered) {
      this.setState({
        isPictureHovered: false,
      })
    }
  }

  handleDeleteFile = (e, index) => {
    e.stopPropagation()
    e.preventDefault()
    const images = this.state.destinationMap[this.state.currentIndex].pictures
    const newImages = [...images.slice(0, index), ...images.slice(index + 1)]
    this.setState({
      destinationMap: {
        ...this.state.destinationMap,
        [this.state.currentIndex]: {
          ...this.state.destinationMap[this.state.currentIndex],
          pictures: newImages,
        },
      },
    })
  }

  handleConfirmDelivery = () => {
    const { load, isClient } = this.props
    const step = get(this.state, `destinationMap[${this.state.currentIndex}]`)

    if (load?.shipper?.flEfectiveDateDelivery && !step.efectiveDeliveryDate) {
      return message.error('Selecione a data efetiva de entrega.')
    }
    if (!step?.pictures?.length)
      return message.error('Adicione no mínimo um comprovante de entrega.')

    if (isClient) {
      const deliveries = [
        ...Object.keys(this.state.destinationMap).map((key) => this.state.destinationMap[key]),
      ]
      this.props.confirmUniqueDelivery(
        load.hashId,
        load.deliveryId,
        deliveries,
        this.props.onCloseClick
      )

      return
    }
    const deliveries = [
      ...Object.keys(this.state.destinationMap).map((key) => this.state.destinationMap[key]),
    ]
    this.props.confirmDelivery(load.deliveryId, load.hashId, deliveries, this.props.onCloseClick)
  }

  renderLocationCard = () => {
    const { load } = this.props
    const deliver = get(load, `destinations[${this.state.currentIndex}]`, null)
    if (!deliver) {
      return null
    }
    const { place } = deliver
    return (
      <div className={css.placeContainer}>
        <div className={css.row}>
          <img alt="place" className={css.locationIcon} src="/assets/icons/placeholder.svg" />
          <div className={css.column} style={{ marginLeft: 24 }}>
            <span className={css.label}>Endereço</span>
            <Textfit mode="single" max={16} className={css.data}>
              {place.place}
            </Textfit>
            <Textfit mode="single" max={14} className={css.data}>
              {place.address}
            </Textfit>
            <Textfit mode="single" max={14} className={css.data}>
              {`${place.city} - ${place.state}`}
            </Textfit>
          </div>
        </div>
        <Textfit mode="single" max={14} className={css.data} style={{ marginTop: 8 }}>
          {get(deliver, 'amount', 0)} {get(deliver, 'unitType.name', '')}(s) de{' '}
          {get(deliver, 'productType.name', '')}({(get(deliver, 'weight', 0) / 1000).toFixed(2)}{' '}
          ton)
        </Textfit>
        <div className={css.row} style={{ marginTop: 5 }}>
          <div className={css.column} style={{ flex: 1 }}>
            <span className={css.label}>Pedido(s)</span>
            {truncateText(deliver.orderCode, 30)}
          </div>
          <div className={css.column} style={{ flex: 1 }}>
            <span className={css.label}>NF(s)</span>
            {truncateText(deliver.nfCode, 30)}
          </div>
        </div>
      </div>
    )
  }

  renderFiles = () => {
    const { currentIndex, destinationMap } = this.state
    const step = destinationMap[currentIndex]
    if (step && step.pictures && step.pictures.length) {
      return step.pictures.map((item, index) => (
        <div
          className={css.attachmentContainer}
          onMouseEnter={() => this.handlePictureIsHovered(index)}
          onMouseLeave={this.handlePictureIsNotHovered}
          key={cuid()}
        >
          {this.state.isPictureHovered && this.state.hoveredIndex === index ? (
            <div
              className={css.deleteContainer}
              tabIndex={0}
              role="button"
              onClick={(e) => this.handleDeleteFile(e, index)}
            >
              <Icon type="delete" theme="filled" style={{ color: '#f5222d', fontSize: 20 }} />
            </div>
          ) : null}
          <img className={css.attachment} src={item.preview} alt="preview" key={cuid()} />
          <span className={css.attachmentLabel}>{item.name}</span>
        </div>
      ))
    }
    return (
      <div className={css.column}>
        <img alt="upload" src="/assets/icons/upload-button.svg" className={css.iconUpload} />
        <span className={css.data} style={{ textAlign: 'center' }}>
          Arraste uma ou mais imagens para cá...
        </span>
        <span className={css.data} style={{ textAlign: 'center', fontSize: 13 }}>
          (.png, .jpg, .jpeg)
        </span>
      </div>
    )
  }

  renderImagesInput = () => {
    const { currentIndex, destinationMap } = this.state
    const step = destinationMap[currentIndex]
    return (
      <Dropzone
        className={css.dropzone}
        onDrop={this.onDropImages}
        style={
          !step || !step.pictures || !step.pictures.length
            ? { justifyContent: 'center', alignItems: 'center' }
            : null
        }
        multiple
      >
        {this.renderFiles()}
      </Dropzone>
    )
  }

  renderObservationInput = () => (
    <Formsy>
      <div style={{ display: 'flex', flex: 0.9, flexDirection: 'row', justifyContent: 'center' }}>
        <CustomInput
          name="observation"
          placeholder="Escreva aqui alguma observação sobre a entrega caso necessário..."
          style={{ display: 'flex', flex: 1 }}
          inputStyle={{ height: 64, width: '100%', resize: 'none' }}
          formStyle={{ width: '100%' }}
          textArea
          gray
          required
          onChange={this.handleChangeObservation}
          value={this.state.destinationMap[this.state.currentIndex].observation}
        />
      </div>
    </Formsy>
  )
  renderFooterButtons = () => {
    const { load } = this.props
    const { currentIndex } = this.state
    const len = get(load, 'destinations.length', 0)
    if (currentIndex === len - 1) {
      return (
        <div className={css.row} style={{ justifyContent: 'flex-end' }}>
          {currentIndex > 0 ? (
            <Button style={{ marginRight: 24 }} onClick={this.handlePreviousClick}>
              <Icon type="left" />
              Anterior
            </Button>
          ) : null}
          <Button type="primary" onClick={this.handleConfirmDelivery}>
            Confirmar entrega <Icon type="check" />
          </Button>
        </div>
      )
    }
    return (
      <div className={css.row} style={{ justifyContent: 'flex-end' }}>
        {currentIndex > 0 ? (
          <Button style={{ marginRight: 24 }} onClick={this.handlePreviousClick}>
            <Icon type="left" />
            Anterior
          </Button>
        ) : null}
        <Button type="primary" onClick={this.handleNextClick}>
          Próximo <Icon type="right" />
        </Button>
      </div>
    )
  }
  renderSteps = () => {
    const { load } = this.props
    const { destinations } = load
    if (destinations && destinations.length > 1) {
      return (
        <div style={{ marginTop: 16 }}>
          <Steps size="small" current={this.state.currentIndex}>
            {load.destinations.map(() => (
              <Step title="" description="" key={cuid()} />
            ))}
          </Steps>
        </div>
      )
    }
    return null
  }
  render() {
    const { load, isClient } = this.props
    const { currentIndex, destinationMap } = this.state
    const step = destinationMap[currentIndex]
    const len = get(load, 'destinations.length', 0)
    return (
      <React.Fragment>
        {this.renderSteps()}
        {!isClient && (
          <span className={css.section}>
            Entrega ({`${this.state.currentIndex + 1} de ${len}`})
          </span>
        )}
        {this.renderLocationCard()}
        {load?.shipper?.flEfectiveDateDelivery && (
          <div style={{ marginBottom: 16 }}>
            <span className={css.section}>Data Efetiva de Entrega</span>
            <div className="row" style={{ flexWrap: 'nowrap' }}>
              <DefaultDatePicker
                value={step.efectiveDeliveryDate}
                onChange={(date) =>
                  this.setState({
                    destinationMap: {
                      ...this.state.destinationMap,
                      [this.state.currentIndex]: {
                        ...this.state.destinationMap[this.state.currentIndex],
                        efectiveDeliveryDate: date,
                      },
                    },
                  })
                }
                mode="single"
                showTime
                placeholder="Selecionar data"
                maxDate={new Date()}
                containerStyle={{ marginRight: 8 }}
                preserveTime
                localeFormat="DD/MM/YYYY HH:mm:ss"
              />
              <TimeSelector
                dateString={step.efectiveDeliveryDate}
                onChange={(date) =>
                  this.setState({
                    destinationMap: {
                      ...this.state.destinationMap,
                      [this.state.currentIndex]: {
                        ...this.state.destinationMap[this.state.currentIndex],
                        efectiveDeliveryDate: date,
                      },
                    },
                  })
                }
                localeFormat="DD/MM/YYYY HH:mm:ss"
              />
            </div>
          </div>
        )}
        <span className={css.section}>
          Comprovantes e outros anexos ({this.state.pictures.length})
        </span>
        {this.renderImagesInput()}
        <span className={css.section}>Observação sobre esta entrega</span>
        {this.renderObservationInput()}
        <div style={{ marginTop: 24 }}>{this.renderFooterButtons()}</div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  mappedLoadsDetailsByHash: state.loadsDetails.mappedLoadsDetailsByHash,
})

const mapActionsToProps = (dispatch) => ({
  confirmDelivery(deliveryId, hashId, deliveries, cb) {
    dispatch(pendingConfirmDelivery(deliveryId, hashId, deliveries, cb))
  },
  confirmUniqueDelivery(hashId, deliveryId, payload, cb) {
    dispatch(pendingConfirmUniqueDelivery(hashId, deliveryId, payload, cb))
  },
})

export default withRouter(connect(mapStateToProps, mapActionsToProps)(Client))
